import React, { Component } from "react";
import Item from "./../components/Item";
import { word } from "../words.js";
import notfound from "./../asset/images/notfound.png";

export default class Group extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
    };

    this.updateInfo = this.updateInfo.bind(this);
  }

  componentDidMount() {
    this.updateInfo();
  }

  componentDidUpdate(prvProps) {
    if (
      prvProps.nameObj !== this.props.nameObj ||
      prvProps.currentLang !== this.props.currentLang
    ) {
      this.updateInfo();
    }
  }

  updateInfo() {
    if (!this.props.nameObj) return;
    let title = "";
    this.props.nameObj.forEach((element) => {
      if (element.languageId === this.props.currentLang.languageId) {
        title = element.name;
      }
    });

    if (title === "") {
      this.props.nameObj.forEach((element) => {
        if (element.languageId === this.props.defaultLangId) {
          title = element.name;
        }
      });
    }

    if (title === "") {
      this.props.nameObj.forEach((element) => {
        if (title === "") {
          title = element.name;
        }
      });
    }

    this.setState({ title: title });
  }

  ChangeOrder(data) {
    this.props.ChangeOrder(data, false);
  }

  render() {
    return (
      <div
        id={"g_" + this.props.catId}
        className="container mt-5 pt-5 category"
      >
        <div className="TitleCatContainer">
          <div
            style={{
              height: "1px",
              minHeight: "1px",
              backgroundColor: "var(--brown2)",
              width: "100%",
              position: "absolute",
              left: "0px",
              top: "50%",
            }}
          />
          <div
            className="TitleCat"
            style={{
              paddingLeft:
                this.props.currentLang.direction === "rtl" ? "10px" : "0px",
              paddingRight:
                this.props.currentLang.direction === "ltr" ? "10px" : "0px",
            }}
          >
            {this.state.title}
          </div>
        </div>

        {this.props.notFound && (
          <div className="row">
            <div
              className={
                this.props.currentLang.direction === "rtl"
                  ? "not-found IRANSansMobileBoldFont"
                  : "not-found SFUIDisplayBoldFont"
              }
            >
              <img
                src={notfound}
                style={{ marginBottom: "10px" }}
                alt="not found"
              />
              {word[this.props.currentLang.tag]["notFound"]}
            </div>
          </div>
        )}

        {!this.props.notFound && (
          <div className="grid">
            {this.props.foods.map((item, i) => {
              if (item.isEnable) {
                return (
                  <Item
                    key={i}
                    currentLang={this.props.currentLang}
                    isTable={this.props.isTable}
                    currentOrder={this.props.currentOrder}
                    catId={this.props.catId}
                    foodItem={item}
                    businessId={this.props.businessId}
                    id={item.id}
                    nameObj={item.nameObj}
                    descrObj={item.descrObj}
                    price={item.price}
                    unit={this.props.unit}
                    img1={item.foodPicS1}
                    img2={item.foodPicS2}
                    img3={item.foodPicS3}
                    ChangeOrder={this.ChangeOrder.bind(this)}
                  />
                );
              } else {
                return null;
              }
            })}
          </div>
        )}
      </div>
    );
  }
}
